import { Component } from 'react';

import './error-message.css';

export class ErrorMessage extends Component {
   render() {
      return (
         <div className="error-message">
            <div className="error-message-text">
               {this.props.text}
            </div>
            {this.props.children}
         </div>
      )
   }
}